<template>
    <div class="grcform">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>


    <div style="width:100%; box-sizing:border-box; padding-bottom: 0px; margin-bottom: 20px; display: inline-block;">
        <div style="width:100%; text-align:left; margin-bottom:10px;">
            <h2 class="painted_header_h2 color3"><span><b>Kritikus betegséghez kapcsolódó számlák feltöltése</b></span></h2>
        </div>
        <div style="width:100%; text-align:left; margin-bottom:10px;">
            <span class="painted_linkbutton2 color4"><span>{{UgyfelNev}}</span></span>
        </div>
    </div>


    <div style="width:100%; box-sizing:border-box;">
      <div style="padding-bottom: 20px; width:100%; box-sizing:border-box;">

          <div class="infotext1" v-html="Leiras"></div>


          <template v-for="(item, index)  in Files">

            <div class="szla_cont" v-show="item.Deleted==false" :key="index">
                <table style="width:100%; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                    <tr>
                        <td class="szla_header">Számla kép</td>
                        <!-- <td class="szla_header">#{{item.SzamlaIndex}} Számla</td>
                        <td class="szla_delicon" style="display:none;" title="számla törlése" @click="btnDelSzamla_click(index)">
                            <span><i class="fas fa-trash-alt"></i></span>
                        </td>
                        -->
                    </tr>
                </table>


                <component ref="szamlamultidoc" :is="item.Component" :key="item.vmi" v-show="item.Deleted==false"
                :grc_shownoti="item.ShowNoti" :grc_maxfiles="item.MaxFiles" :grc_allowed_extensions="item.AllowedExtensions"
                >
                </component>
            </div>            

          </template>


          <div style="width:100%; box-sizing:border-box; text-align:center; margin: 30px 0px 10px 0px;">
            <GrcBankszla ref="txtBankszamlaszam" v-model="txtBankszamlaszam"
            grc_labeltext="Bankszámlaszám, amire az utalást kérem:"
            grc_placeholder=""
            grc_labelmode="above" grc_labelwidth="300px" 
            grc_readonly="false"
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="width:100%; max-width:400px; display:inline-block;"
            />
          </div>


            <div ref="btncont1" class="btncont" style="text-align: center; margin: 30px 0px 10px 0px;">

                <span @click="btnOK_click" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                    <span><i class="fal fa-check" style="margin-right: 4px;"></i>Számla beküldése</span>
                </span>                                        

            </div>
         


        </div>
      </div>

    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'
import GrcBankszla from '../GrcComponents/GrcBankszla.vue'

export default {
  name: 'frmkritikusszamlafeltoltes',
  components: {
      GrcDB,
      GrcDialog,
      GrcDocMultiSelect,
      GrcBankszla,
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmKritikusSzamlaFeltoltes_",

          Files: [],
          Leiras:"",
          UgyfelID:0,
          UgyfelNev:"",
          txtBankszamlaszam:"",

          MaxFiles:"-1",
          AllowedExtensions:"pdf, jpg, png",

      }
  },
  model: {

  },  
  methods:{

    SetLang()
    {
      this.Init();
    },


      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },

      btnAddSzamla_click()
      {
          var ind = 0;
          for(var i=0; i<this.Files.length; i++)
          {
              if (this.Files[i].Deleted == false)
              {
                  ind++;
              }
          }

          ind++;

          this.Files.push({ vmi: this.Files.length+1, Component: GrcDocMultiSelect, Deleted:false, SzamlaIndex:ind, ShowNoti:"true", MaxFiles:this.MaxFiles, AllowedExtensions:this.AllowedExtensions });
      },

    async btnDelSzamla_click(pIndex)
    {
        return;

        var DialogResult = "";
        var infotext = "Biztosan törli a listából a számlát?";

        var p = grccomp_dialog_yesno_GetDefaults(grcmain_GetTextBookItem("tech", "megerosites"), infotext);             
        p.height = 200;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }

        
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });        

        if (DialogResult != "YES") { return; }


          var ind = 0;
          this.Files[pIndex].Deleted = true;
          for(var i=0; i<this.Files.length; i++)
          {
              if (this.Files[i].Deleted == false)
              {
                  ind++;
                  this.Files[i].SzamlaIndex = ind;
              }
          }

    },



      btnOK_click()
      {
        this.Mentes();
      },

      async Init()
      {
        this.UgyfelID = gDashboardUgyfelID;

          this.Files = [];

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iUgyfelID: this.UgyfelID,
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();

            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            document.location = "dashboard";
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT.length == 0)
        {
            document.location = "dashboard";
            return;
        }

        if (Q.RESULT[0].SzamlaEngedely == 0)
        {
            document.location = "dashboard";
            return;
        }

        this.$refs.txtBankszamlaszam.SetText(Q.RESULT[0].Bankszamlaszam);

        this.UgyfelNev = Q.RESULT[0].UgyfelNev;
        this.Leiras = Q.RESULT[0].Leiras;
        this.Files.push({ vmi: 0, Component: GrcDocMultiSelect, Deleted:false, SzamlaIndex:1, ShowNoti:"true", MaxFiles:this.MaxFiles, AllowedExtensions:this.AllowedExtensions });

      },


      async Mentes()
      {
        this.$refs.GRCDB.ShowLoading(false);

        var pFajlok = ""; 
        var FajlCheck = true;
        var FajlCheck2 = false;

        var UploadOK = true;
        for(var i=0; i<this.Files.length; i++)
        {
            if (this.Files[i].Deleted == false)
            {
              FajlCheck2 = true;

              var UploadRes = await this.$refs.szamlamultidoc[i].UploadFiles(1);

              //console.log(UploadRes);

              if (UploadRes.FileCount == 0) { FajlCheck = false; break; }
              if (UploadRes.UploadID == "") { UploadOK = false; break; }
              if (UploadRes.Success == false) { UploadOK = false; break; }
              
              pFajlok = pFajlok + "<SZAMLA>"
              +"<UploadID><![CDATA["+UploadRes.UploadID+"]]></UploadID>"
              +"<Megjegyzes><![CDATA["+UploadRes.Megjegyzes+"]]></Megjegyzes>"
              +"</SZAMLA>";

            }
        }

        if (UploadOK == false)
        {
          this.$refs.GRCDB.HideLoading();
          await this.ShowInfo("A számla feltöltés előkészítése sikertelen!", 200);
          return;
        }

        if (FajlCheck2 == false)
        {
          this.$refs.GRCDB.HideLoading();
          await this.ShowInfo("Legalább egy számla megadása kötelező!", 200);
          return;
        }

        if (FajlCheck == false)
        {
          this.$refs.GRCDB.HideLoading();
          await this.ShowInfo("Minden számlához legalább egy fájl megadása kötelező!", 200);
          return;
        }


        pFajlok = "<NewDataSet>" + pFajlok + "</NewDataSet>";

        /*
        console.log(pFajlok);
        this.$refs.GRCDB.HideLoading();
        console.log("Eddig OK");
        return;
        */
              
      

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            sFajlok: pFajlok,
            sBankszamlaszam: this.$refs.txtBankszamlaszam.GetText(),
            iUgyfelID: this.UgyfelID,
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Save", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        /*
        var Azonositok = "<ul>";
        for(var i=0; i<Q.RESULT.length; i++)
        {
          Azonositok = Azonositok + "<li>" + Q.RESULT[i].KarAzonosito+"</li>";
        }
        Azonositok = Azonositok + "</ul>";
        */

       let Azonosito = Q.RESULT[0].KarAzonosito;


        var strRes = 'Az adatok mentése sikeresen megtörtént!<br><br><b>Azonosító: '+Azonosito+"</b>";

        await this.ShowInfo(strRes, 260);

        document.location = "dashboard";

      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 320; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },
  created()
  {

  },
  mounted()
  {
      this.SetLang();
  }

}


</script>


<style scoped>

.szla_cont
{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-family: 'CmsDefault';
    font-size: 14px;
    line-height: 18px;
    color: #444;
    padding: 8px;
    border: solid 1px #ccc;
    border-radius: 0px;
    margin: 10px 0px;
    background-color: rgba(200,200,200,0.2);
}


.szla_header
{
  font-family: 'CmsDefault';
  font-size:20px;
  line-height: 20px;
  color: var(--themecolor3);
  padding:0px;
  font-weight: 500;
}

.szla_delicon
{
  font-size:16px;
  line-height: 16px;
  padding:0px;
  font-family: 'CmsDefault';
  width:30px;
  text-align: center;
  padding:4px 0px;

    background-color: hotpink;
    color: #fff;
    border-radius: 2px;  
}

.szla_delicon:hover
{
    background-color: deeppink;
    cursor:pointer;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}


.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  background-color: var(--premgreen);
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    background-color: var(--premgreen);
    color: #fff;;
}

.infotext1
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:16px;
  line-height: 22px;
  color: #000;
  padding:8px 0px;
  font-weight: 500;
  margin-bottom:0px;

}





@media (max-width:670px)
{

}

</style>